import { toast } from 'react-toastify'
import {AuthModel} from './_models'
import { Logout } from '../Logout'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'
// Admin buyer-view state (see BuyerView.ts)
const ADMIN_AUTH_KEY = 'kt-auth-admin-backup'
const BUYER_INFO_KEY = 'kt-buyer-view-info'
const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    // console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    // console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
    localStorage.removeItem(ADMIN_AUTH_KEY)
    localStorage.removeItem(BUYER_INFO_KEY)
  } catch (error) {
    // console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

// export function setupAxios(axios: any) {
//   axios.defaults.headers.Accept = 'application/json'
//   axios.interceptors.request.use(
//     (config: {headers: {Authorization: string}}) => {
//       const auth = getAuth()
//       if (auth && auth.access_token) {
//         config.headers.Authorization = `Bearer ${auth.access_token}`
//       }

//       return config
//     },
//     (err: any) => Promise.reject(err)
//   )
// }

  // function toast401Error(text) {
  //   toast.dismiss(); 
  //   toast.error(text, { autoClose: 2000 });
  // }

export function setupAxios(axios: any) {
    // const {logout} = useAuth();
  axios.defaults.headers.Accept = 'application/json';

  // ✅ Request Interceptor
  axios.interceptors.request.use(
    (config) => {
      const auth = getAuth();
      if (!config.headers) {
        config.headers = {};
      }

      if (!config.headers['Authorization'] && auth?.access_token) {
        config.headers['Authorization'] = `Bearer ${auth?.access_token}`;
      }

      //  config.headers['Authorization'] = `Bearer ${removedLastLetterOfToken}`;

      return config;
    },
    (err) => Promise.reject(err)
  );

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      // console.log("axios401error",error.response?.status)
      if (error.response?.status === 401) {
        // Buyer-view token expired: fall back to the admin's own session instead of logging out
        const adminBackup = localStorage.getItem(ADMIN_AUTH_KEY)
        if (adminBackup) {
          localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, adminBackup)
          localStorage.removeItem(ADMIN_AUTH_KEY)
          localStorage.removeItem(BUYER_INFO_KEY)
          window.location.href = '/dashboard'
          return Promise.reject(error)
        }
        // toast401Error('Session expired. Please Login again.')
            // toast.error('Session expired. Please Login again.');
                localStorage.removeItem('kt-auth-react-v');
                localStorage.removeItem("newChannelAddedprompt");
                localStorage.removeItem("StopAPIRequest");
                window.location.href = '/login';
                    // setTimeout(() => {
                      Logout();
                    // }, 2100);
           
      }
      return Promise.reject(error);
    }
  );
}

export {getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY, ADMIN_AUTH_KEY, BUYER_INFO_KEY}
